import type { ShipDef } from '../data/schemas'

/** Energy needed to start a boost; once boosting, it continues until empty. */
export const BOOST_MIN_START_ENERGY = 10

export function resolveBoost(wantBoost: boolean, wasBoosting: boolean, energy: number): boolean {
  if (!wantBoost) return false
  return wasBoosting ? energy > 0 : energy >= BOOST_MIN_START_ENERGY
}

export function stepEnergy(energy: number, boosting: boolean, def: ShipDef, dt: number): number {
  if (boosting) return Math.max(0, energy - def.boostEnergyPerSec * dt)
  return Math.min(def.energy, energy + def.energyRegen * dt)
}
